import script from "./NoteMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteMain.vue?vue&type=script&setup=true&lang=js"

import "./NoteMain.vue?vue&type=style&index=0&id=349f3ce6&lang=less&scoped=true"

import exportComponent from "/Users/yangxinyuan/yxy9022/lit-note/node_modules/.pnpm/vue-loader@17.1.1_vue@3.3.2+webpack@5.82.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-349f3ce6"]])

export default __exports__